import { ActiveEditorChangeEvent, EditorService, Emitter } from './interfaces';

export class EditorServiceImpl implements EditorService {

    protected readonly onDidActiveEditorChangeEmitter = new Emitter<ActiveEditorChangeEvent>();
    readonly onDidActiveEditorChange = this.onDidActiveEditorChangeEmitter.event;

    handleActiveEditorChange(event: ActiveEditorChangeEvent): void {
        this.onDidActiveEditorChangeEmitter.fire(event);
    }
}
